export enum ScorecardCategoryPunchcardView {
  /**
   * These is used for the different
   * views related to the punchcard
   * scorecard view.
   */

  /** Default view */
  defaultView = 0,
  /** Punch view should have description on the card */
  descriptionOnCardView = 1,
  /** All punches should have no name shown on the card */
  noActionNamesView = 2,
  /** Punch View for only one punch */
  onePunchView = 3,
}
